module.exports = __webpack_public_path__ + "img/modal-close.5c916169.svg";